import React from 'react'

export const Consultant = () => {
  return (
    <>
        <div class="d-flex flex-column" dir='rtl'>
  
        <div class="block-header d-flex d-md-none flex-row-reverse">
            <div class="d-flex justify-content-center align-items-center flex-row-reverse">
                <img src=".//img/Avatar-Image.png" class="block-header-auth-img rounded-circle" alt="" />
                <button class="btn btn-icon mobile_menu mx-3" type="button"> <i
                        class="zmdi zmdi-settings mx-3"></i></button>
                <button class="btn btn-icon mobile_menu" type="button"> <i class="zmdi zmdi-power"></i></button>
            </div>
            <button class="btn btn-icon mobile_menu custom-bg-primary" type="button" id="mobileMenuOpen"><i
                    class="zmdi zmdi-sort-amount-desc"></i></button>
        </div>
        <section class="m-0 content">
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">درخواست مشاوره</div>
                        <p class="card-subtitle">جهت درخواست مشاوره فرم زیر را تکمیل نمایید</p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره پرونده" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام و نام خانوادگی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پدر" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ تولد" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام بخش" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره اتاق" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تخت" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="پزشک معالج" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <select class="form-select form-control pr-16 my-2 border-primary"
                                aria-label="Default select example">
                                <option selected>عماد صالحی</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 me-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پزشک درخواست کننده" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example">
                                <option selected>نوع مشاوره</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 ms-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ پذیرش" />
                        </div>
                    </div>
                    <div class="seprator my-24"></div>
                    <div class="form-group position-relative w-100">
                        <div class="card-title text-secondary b-16">تشخیص اولیه</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">گزارشات کلینیکی و موضوع مشاوره</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">مشاهدات و نظریات پزشک معالج</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <button class="custom-btn-primary t-24 form-submit p-16">
                        دزخواست مشاوره با عماد صالحی
                    </button>
                </div>
            </div>
        </section>
    </div>
    </>
  )
}
